import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddressValidationRequest } from 'src/app/shared/address-validator/address-validator';

@Injectable({
  providedIn: 'root'
})
export class AddressService
{
  constructor(private http: HttpClient) { }

  public validateAddress(data: AddressValidationRequest): Observable<any>
  {
    return this.http.post('/address/validate', data);
  }

}
